import { MicOffIcon, MicOnIcon } from 'assets/images';
import { translate } from 'store/modules/base/i18n/functions';
import { connect } from 'store/modules/base/redux/functions';
import { isLocalTrackMuted } from 'store/modules/base/tracks/functions';
import { MEDIA_TYPE } from 'store/modules/base/media/constants';
import AbstractButton from './AbstractButton';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import React from 'react';

/**
 * Component that renders a toolbar button for leaving the current conference.
 *
 * @augments AbstractHangupButton
 */
class MicrophoneButton extends AbstractButton {
  accessibilityLabel = 'toolbar.accessibilityLabel.mute';
  label = 'toolbar.microphoneOn';
  toggledLabel = 'toolbar.microphoneOff';
  type = 'gray';
  icon = MicOnIcon;
  toggledIcon = MicOffIcon;

  /**
   * Initializes a new HangupButton instance.
   *
   * @param {Props} props - The read-only properties with which the new
   * instance is to be initialized.
   */
  constructor(props) {
    super(props);
  }

  /**
   * Handles clicking / pressing the button, and disconnects the conference.
   *
   * @protected
   * @returns {void}
   */
  _handleClick() {
    //
  }

  /**
   * Indicates whether this button is in toggled state or not.
   *
   * @override
   * @protected
   * @returns {boolean}
   */
  _isToggled() {
    return this.props._audioMuted;
  }

  /**
   * Indicates if video is currently disabled or not.
   *
   * @override
   * @protected
   * @returns {boolean}
   */
  _isDisabled() {
    return true;
  }
}

/**
 * Maps (parts of) the Redux state to the associated {@code HangupButton}'s props.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} ownProps - The own props of the component.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
  return {
    _audioMuted: isLocalTrackMuted(
      state['features/base/tracks'],
      MEDIA_TYPE.AUDIO
    ),
    _userIdleMode: state['features/settings'].userIdleMode
  };
}
export default React.memo(
  translate(connect(_mapStateToProps)(withBoundary(MicrophoneButton)))
);
